import { removeTheseProps } from '@/utils';
import { styled, Stack, StackProps } from '@mui/material';

export const QRIconContainer = styled(Stack)(({ theme }) => ({
  position: 'absolute',
  fontSize: 50,
  borderRadius: 50,
  padding: 12,
  bottom: 80,
  right: 100,
  zIndex: 99,
  color: theme.palette.blue.main,
  cursor: 'pointer',
  backgroundColor: theme.palette.blue100.main,
  boxShadow: '0px 0px 25px 10px rgba(37, 93, 167, 0.3)',
  '&:hover': {
    backgroundColor: theme.palette.blue400.main,
  },
}));

export const StyledCardContainer = styled(Stack)(({ theme }) => ({
  borderRadius: 5,
  gap: 20,
  fontWeight: 500,
  fontSize: 21,
  padding: '30px 21px',
  borderLeft: `3px solid ${theme.palette.skyBlue100.main}`,
  boxShadow: '0px 0px 15px 1px rgba(37, 93, 167, 0.06)',
}));

export const StyledContainer = styled(Stack)(({}) => ({
  borderRadius: 5,
  padding: '30px 20px',
  boxShadow: '0px 0px 15px 1px rgba(37, 93, 167, 0.06)',
}));

export const CustomGreen = styled(Stack)(({ theme }) => ({
  width: 40,
  height: 40,
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: 20,
  backgroundColor: theme.palette.green.main,
}));

export const CustomBlue = styled(Stack)(({ theme }) => ({
  width: 40,
  height: 40,
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: 20,
  backgroundColor: theme.palette.skyBlue100.main,
}));

export const CustomYellow = styled(Stack)(({ theme }) => ({
  width: 40,
  height: 40,
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: 20,
  backgroundColor: theme.palette.yellow.main,
}));

export const CustomRed = styled(Stack)(({ theme }) => ({
  width: 40,
  height: 40,
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: 20,
  backgroundColor: theme.palette.red300.main,
}));

type CustomContainerProps = StackProps & {
  color: string;
};

export const CustomContainer = styled(Stack, {
  shouldForwardProp: removeTheseProps<CustomContainerProps>('color'),
})<CustomContainerProps>(({ color }) => ({
  padding: 20,
  borderRadius: 16,
  backgroundColor: color + '10',
  gap: 20,
}));
